import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { inject, observer } from "mobx-react";
import "../../../assets/css/components/Modal/Modal.css";

const ForgotPassword = inject("sharedStore")(
  observer((props) => {
    const [email, setEmail] = useState("");
    const [formErrCnfrmPass, setFormErrCnfrmPass] = useState("");
    const {
      sharedStore,
      closeModalHandler,
      modalClass,
      modalVisibility,
      switchModalVisibility,
    } = props;

    useEffect(() => {
      Modal.setAppElement("body");
    }, []);

    const onChange = ({ target }) => {
      setEmail(target.value);
    }

    const onFormSubmit = (e) => {
      if (email === "") {
        return;
      }
      sharedStore.showLoader();
      setFormErrCnfrmPass("Please wait..");
      return fetch("api/user/sendOtp/", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ "email": email }),
      }).then((json) => {
        sharedStore.hideLoader();
        if (json.error === false) {
          setEmail();
          setFormErrCnfrmPass();
          switchModalVisibility(null, 1, { email: email });
        } else {
          setFormErrCnfrmPass(json.email[0]);
        }
      }).catch(err => {
        setEmail("")
        setFormErrCnfrmPass("Internal Server Error.Please try again later")
      })
    };

    return (
      <Modal
        isOpen={modalVisibility}
        onRequestClose={closeModalHandler}
        shouldCloseOnOverlayClick={false}
        contentLabel="Forgot Password Modal"
        className={modalClass}
      >
        <div className="text-right">
          <span className="span-style" onClick={closeModalHandler}>
            <i className="fa fa-close" aria-hidden="true"></i>
          </span>
        </div>
        <div className="inner">
          <form>
            <label className="password-heading text-center">
            Forgot Your Password?
            </label>
            <label className="text-center label-bottom">
            Please enter the email address you use to sign in.
            </label>
            <p className="text-danger">{formErrCnfrmPass}</p>
            <input
              type="text"
              placeholder="Enter Your Email"
              className="prompt-text text-top form-control"
              name="email"
              value={email}
              onChange={onChange}
              required
            />
            <div className="row col-md-12">
              <button
                className="col-md-6 btn-red btn-align"
                type="button"
                onClick={(e) => onFormSubmit(e)}
              >
                <p className="center">Submit</p>
              </button>
            </div>
          </form>
        </div>
      </Modal>
    );
  })
);


export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/Authentication/ForgotPassword/ForgotPassword.jsx